if (!customElements.get('infinite-scroll-trigger')) {
  customElements.define(
    'infinite-scroll-trigger',
    class InfiniteScrollTrigger extends HTMLElement {
      connectedCallback() {
        this.loading = false;
        this.sectionId = this.getAttribute('data-section-id');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) this.loadNextPage();
          },
          { rootMargin: '600px 0px 600px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      getNextUrl() {
        const nextUrl = this.getAttribute('data-next-url');
        if (!nextUrl) return null;
        const separator = nextUrl.includes('?') ? '&' : '?';
        return `${nextUrl}${separator}section_id=${this.sectionId}`;
      }

      async loadNextPage() {
        const url = this.getNextUrl();
        if (!url || this.loading) return;
        this.loading = true;
        this.setAttribute('data-loading', 'true');

        try {
          const response = await fetch(url);
          if (!response.ok) throw new Error('Infinite scroll: request failed');
          const text = await response.text();
          const doc = new DOMParser().parseFromString(text, 'text/html');

          const newGrid = doc.getElementById('product-grid');
          const currentGrid = document.getElementById('product-grid');
          if (newGrid && currentGrid) {
            Array.from(newGrid.children).forEach((item) => {
              item.classList.remove('scroll-trigger', 'animate--slide-in');
              item.removeAttribute('data-cascade');
              item.removeAttribute('style');
              currentGrid.appendChild(item);
            });
          }

          const newTrigger = doc.querySelector('infinite-scroll-trigger');
          const nextUrl = newTrigger ? newTrigger.getAttribute('data-next-url') : null;

          if (nextUrl) {
            this.setAttribute('data-next-url', nextUrl);
          } else {
            this.observer.disconnect();
            this.remove();
            return;
          }
        } catch (error) {
          console.error('Infinite scroll: could not load next page', error);
          this.observer.disconnect();
        } finally {
          this.loading = false;
          this.removeAttribute('data-loading');
        }
      }
    }
  );
}
